export default "__VITE_ASSET__e115a308__"